@if (isNavigating()) {
  <div class="nav-progress" role="progressbar" aria-label="Ładowanie strony">
    <div class="nav-progress__bar"></div>
  </div>
}

<div class="app-shell" *ngIf="!isLoggedIn">
  <div class="app-shell__content">
    <router-outlet />
  </div>
</div>

<app-dashboard-layout *ngIf="isLoggedIn"></app-dashboard-layout>

<p-toast />
